import { moduleUrl } from "scriptsShared/Utils.js";


export const getLogoUrl = (partnerId) => {
    if (!partnerId) return null;
    return moduleUrl() + "Partner/" + partnerId + "/logo";
}

// moduleBase = URL of the PersonalLoan module; pass it from pages outside the module.
export const getLogoUrlByCode = (code, moduleBase = moduleUrl()) => {
    if (!code) return null;
    return moduleBase + "Partner/logo/code/" + encodeURIComponent(code);
}
